module.exports = __webpack_public_path__ + "img/zhoujiadu-logo.0a8423a8.jpg";